import {
    SIDEBAR_DATA_LOADED,
    COMMAND_LOADING,
    EXECUTE_COMMAND,
    COMMAND_LOADED,
    COMMAND_FAILED,
    DASHBOARD_LOADING,
    DASHBOARD_LOADED,
    DASHBOARD_FAILED,
    COMMANDLOG_LOADING,
    COMMANDLOG_LOADED,
    COMMANDLOG_FAILED,
    TODAY_ACTIVITIES_LOADING,
    TODAY_ACTIVITIES_LOADED,
    TODAY_ACTIVITIES_FAILED,
    ROUTEPATHCHANGE,
    LOGOUT,
} from '../types';

import { created } from '../../helpers/reduxUtils';

const initialState = {
    loading: false,
    commandLoading: false,
    activityLoading: false,
    menuItems: [],
    commands: [],
    commandLogs: [],
    dashboard: null,
    activities: [],
    routes: {},
};

export default function(state = initialState, action) {
    switch (action.type) {
        case TODAY_ACTIVITIES_LOADING:
            return {
                ...state,
                activityLoading: true,
            };

        case DASHBOARD_LOADING:
            return {
                ...state,
                loading: true,
            };
        case COMMANDLOG_LOADING:
        case COMMAND_LOADING:
            return {
                ...state,
                commandLoading: true,
            };
        case COMMAND_LOADED:
            return {
                ...state,
                commandLoading: false,
                commands: action.payload,
            };
        case EXECUTE_COMMAND:
            return {
                ...state,
                commandLoading: false,
                commandLogs: created(state.commandLogs, action.payload),
            };
        case SIDEBAR_DATA_LOADED:
            return {
                ...state,
                menuItems: action.payload,
            };
        case DASHBOARD_LOADED:
            return {
                ...state,
                loading: false,
                dashboard: action.payload,
            };
        case TODAY_ACTIVITIES_LOADED:
            return {
                ...state,
                loading: false,
                activityLoading: false,
                activities: action.payload,
            };
        case TODAY_ACTIVITIES_FAILED:
            return {
                ...state,
                activityLoading: false,
            };
        case COMMANDLOG_LOADED:
            return {
                ...state,
                commandLoading: false,
                commandLogs: action.payload,
            };
        case DASHBOARD_FAILED:
            return {
                ...state,
                loading: false,
            };
        case COMMANDLOG_FAILED:
        case COMMAND_FAILED:
            return {
                ...state,
                commandLoading: false,
            };
        case ROUTEPATHCHANGE:
            return {
                ...state,
                routes: action.payload,
            };
        case LOGOUT:
            return {
                ...state,
                menuItems: [],
            };
        default:
            return state;
    }
}